import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Magic UI — Animated Gradient Text
 * https://magicui.design/docs/components/animated-gradient-text
 */
export function AnimatedGradientText({ children, className, ...props }) {
  return (
    <div
      className={cn(
        'group relative mx-auto flex max-w-fit flex-row items-center justify-center rounded-2xl px-4 py-1.5 text-sm font-medium backdrop-blur-sm transition-shadow duration-500 ease-out',
        '[background:linear-gradient(to_right,rgba(255,255,255,0.05),rgba(255,255,255,0.02))]',
        'border border-white/10 shadow-[inset_0_-2px_10px_rgba(255,255,255,0.08)]',
        className
      )}
      {...props}
    >
      <div
        className={cn(
          'absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#6366f1]/50 via-[#8b5cf6]/50 to-[#a855f7]/50 bg-[length:var(--bg-size)_100%] p-[1px]',
          '![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]'
        )}
        style={{ '--bg-size': '300%' }}
      />
      {children}
    </div>
  );
}

/**
 * Reusable animated gradient text span (the shimmering colored text itself).
 */
export function GradientTextSpan({ children, className }) {
  return (
    <span
      style={{ '--bg-size': '300%' }}
      className={cn(
        'animate-gradient bg-gradient-to-r from-[#818cf8] via-[#c084fc] to-[#818cf8] bg-[length:var(--bg-size)_100%] bg-clip-text text-transparent',
        className
      )}
    >
      {children}
    </span>
  );
}
